export type PersonGrpEnrollmentNode = {
  accountOpenedOn: string;
  person?: { pgaId?: string | null } | null;
};

export function findPersonGrpEnrollment(
  nodes: PersonGrpEnrollmentNode[] | undefined,
  pgaId: string
): PersonGrpEnrollmentNode | undefined {
  return nodes?.find((node) => node.person?.pgaId === pgaId);
}

export function isTruncatedPersonGrpEnrollmentLookup(
  enrollment: PersonGrpEnrollmentNode | undefined,
  hasNextPage: boolean
): boolean {
  return !enrollment && hasNextPage;
}
